import Phaser from 'phaser';
import { TEXTURE_KEYS } from '../systems/util/constants.js';
import { buildSidebar, resolveStartLevelId, SIDEBAR_W, INK_NUM } from '../systems/ui/chrome.js';
import levels from '../../data/levels.json';

export class Menu extends Phaser.Scene {
  constructor() {
    super('Menu');
  }

  create() {
    const { width, height } = this.scale;
    this.cameras.main.setBackgroundColor('#ffffff');

    // Hero art: the skyline (far parallax layer) behind a rooftop bunker
    // (near parallax layer), reusing the same comic-art assets the levels
    // themselves are built from so the menu reads as "the same world".
    const sky = this.add.image(width, 4, TEXTURE_KEYS.BG_FAR_1).setOrigin(1, 0).setAlpha(0.55);
    sky.setScale((height - 4) / sky.height);

    const roof = this.add.image(width - 70, height + 2, TEXTURE_KEYS.BG_NEAR_1).setOrigin(1, 1);
    roof.setScale((height * 0.82) / roof.height);

    this.add.rectangle(SIDEBAR_W + (width - SIDEBAR_W) / 2, height - 1, width - SIDEBAR_W, 2, INK_NUM);

    buildSidebar(this, {
      active: 'start',
      onNav: (key) => {
        if (key === 'start') this.scene.start('Game', { levelId: resolveStartLevelId(levels) });
        if (key === 'levels') this.scene.start('LevelSelect');
      }
    });

    this.input.keyboard?.once('keydown-ENTER', () => this.scene.start('Game', { levelId: resolveStartLevelId(levels) }));
  }
}
